/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Zakelijk bestellen — vinkje in de winkelwagen en het zijpaneel.
 *
 * Werkt met gedelegeerde listeners omdat het zijpaneel door het thema opnieuw
 * wordt opgebouwd. De blokken zelf staan in snippets/zakelijk-bestellen.liquid.
 */
(function () {
  'use strict';

  var saveTimer = null;

  function getBlock(element) {
    return element ? element.closest('[data-business-order]') : null;
  }

  /**
   * De waarden meteen in de winkelwagen zetten in plaats van te wachten op het
   * versturen van het formulier. Anders gaan ze verloren zodra iemand met een
   * sneltoets-knop (Shop Pay, PayPal) afrekent, want die slaat het formulier over.
   */
  function saveToCart(block) {
    var toggle = block.querySelector('[data-business-order-toggle]');
    // Sleutelnamen bewust kleingeschreven en zonder spaties: het factuursjabloon
    // van Order Printer Pro leest 'vatid' al uit, en Liquid struikelt over
    // streepjes in de puntnotatie.
    var attributes = {
      'zakelijk': toggle.checked ? 'Ja' : '',
      'bedrijfsnaam': '',
      'vatid': '',
      'referentie': ''
    };

    if (toggle.checked) {
      Array.prototype.forEach.call(block.querySelectorAll('input[type="text"][name]'), function (input) {
        var match = input.name.match(/^attributes\[(.+)\]$/);
        if (match) {
          attributes[match[1]] = input.value.trim();
        }
      });
    }

    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      }).catch(function () {
        // Mislukt opslaan is niet fataal: bij het afrekenen gaat het formulier alsnog mee.
      });
    }, 400);
  }

  function sync(block, focusCompany) {
    var toggle = block.querySelector('[data-business-order-toggle]');
    var fields = block.querySelector('[data-business-order-fields]');
    var flag = block.querySelector('[data-business-order-flag]');
    var isBusiness = toggle.checked;

    fields.hidden = !isBusiness;
    flag.value = isBusiness ? 'Ja' : '';

    if (!isBusiness) {
      // Leegmaken, anders reizen oude waarden alsnog mee naar de bestelling.
      Array.prototype.forEach.call(fields.querySelectorAll('input[type="text"]'), function (input) {
        input.value = '';
        input.classList.remove('is-filled');
      });
      clearError(block);
    } else if (focusCompany) {
      var company = block.querySelector('[data-business-order-company]');
      if (company) {
        company.focus();
      }
    }
  }

  function clearError(block) {
    var existing = block.querySelector('.business-order__error');
    if (existing) {
      existing.parentNode.removeChild(existing);
    }
  }

  function showError(block, message) {
    clearError(block);
    var paragraph = document.createElement('p');
    paragraph.className = 'business-order__error';
    paragraph.setAttribute('role', 'alert');
    paragraph.textContent = message;
    var company = block.querySelector('[data-business-order-company]');
    var anchor = company ? company.parentNode : block;
    anchor.parentNode.insertBefore(paragraph, anchor.nextSibling);
    if (company) {
      company.focus();
    }
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-business-order-toggle]')) {
      return;
    }
    var block = getBlock(event.target);
    sync(block, true);
    saveToCart(block);
  });

  document.addEventListener('input', function (event) {
    var block = getBlock(event.target);

    if (!block || !event.target.matches('.business-order__fields input[type="text"]')) {
      return;
    }

    if (event.target.matches('[data-business-order-company]') && event.target.value.trim() !== '') {
      clearError(block);
    }

    saveToCart(block);
  });

  // Een onvolledig ingevuld blok mag de bestelling tegenhouden, een fout in deze
  // controle nooit: bij onverwachte problemen gaat het afrekenen gewoon door.
  document.addEventListener('submit', function (event) {
    try {
      var form = event.target;
      var block = form.querySelector('[data-business-order]');

      if (!block) {
        return;
      }

      var toggle = block.querySelector('[data-business-order-toggle]');
      var company = block.querySelector('[data-business-order-company]');

      if (!toggle.checked || company.value.trim() !== '') {
        return;
      }

      event.preventDefault();
      showError(block, block.getAttribute('data-error-company'));
    } catch (error) {
      // Bewust stil: het afrekenen mag hier nooit op stuklopen.
    }
  });
})();

